import { CalculatorDescription } from '../../../lib/calculators/calculator-description';
import { CalculatorId } from '../../../lib/calculators/calculator-config';

export const binomialDescription: CalculatorDescription = {
  id: CalculatorId.BINOMIAL_DISTRIBUTION,
  title: 'Binomial Distribution Calculator',
  metaTitle: 'Online Binomial Distribution Calculator - Probability Tool',
  description: 'Calculate probabilities for binary outcome events using the binomial distribution. Perfect for analyzing success/failure scenarios and probability distributions.',
  metaDescription: 'Calculate binomial probabilities online. Analyze success/failure scenarios with our free probability calculator. Perfect for statistical analysis.',
  howTo: {
    title: 'How to Use Binomial Calculator',
    steps: [
      'Enter number of trials (n)',
      'Set probability of success (p)',
      'Choose calculation type',
      'Specify success count (k)',
      'View probability results'
    ]
  },
  examples: [
    {
      title: 'Quality Control',
      description: 'Analyzing defect rates in manufacturing',
      dataDescription: 'Binary outcomes (defect/no defect) across multiple production batches',
      insights: [
        'Shows probability of specific defect counts',
        'Calculates cumulative failure rates',
        'Predicts batch quality probabilities',
        'Helps set quality control thresholds'
      ]
    },
    {
      title: 'Survey Analysis',
      description: 'Analyzing yes/no survey responses',
      dataDescription: 'Binary response data from survey participants',
      insights: [
        'Shows probability of response patterns',
        'Calculates likelihood of survey outcomes',
        'Predicts response distributions',
        'Helps determine sample size needs'
      ]
    }
  ],
  relatedCalculators: [
    CalculatorId.ANOVA
  ]
}; 